export default {"src":"/_next/static/media/caret-right-solid.bd07f964.svg","height":512,"width":256};